/**
 * Returns true when the given CTA visual value is a default (preset) visual ID
 * (i.e. a string that begins with "default"), as opposed to a custom uploaded
 * file or a null (no visual) value.
 */
export const isDefaultCTAVisual = (
  visual: string | File | null
): visual is string =>
  typeof visual === "string" && visual.startsWith("default");
